import { Outlet } from 'react-router-dom';
import useMediaQuery from '../../hooks/useMediaQuery';
import NavigationBar from '../../components/builder/Interface/NavigationBar/NavigationBar';
import { isDemo } from '../../GlobalContex';
import Preview from '../../components/builder/Preview/Preview';
import Auth from '../../components/Auth';
import PreviewWrapper from '../../components/builder/Preview/PreviewWrapper/PreviewWrapper';
import styles from './AppLayout.module.css';

const Account = isDemo ? ({ children }) => children : Auth;

export const AppLayout = () => {
  const isMobile = useMediaQuery({ max: 991 });

  return (
    <Account>
      {isMobile ? (
        <>
          <Outlet />
          {isDemo && <Preview />}
          <NavigationBar />
        </>
      ) : (
        <>
          <NavigationBar />
          <div className={styles.PreviewInApp + ' h-100 position-fixed'}>
            <div className="h-100 d-flex">
              <div className={styles.LeftPanel}>
                <div className="small-edit-window-wrapper">
                  <Outlet />
                </div>
              </div>
              <div className={styles.Preview}>
                <div className="edit-window-wrapper h-100">
                  <PreviewWrapper>
                    <Preview />
                  </PreviewWrapper>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </Account>
  );
};
